import { ReactNode, useCallback, useEffect, useState } from 'react';
import { Hub } from 'aws-amplify/utils';
import { env } from '@/lib/env';
import { isSignedIn } from '@/lib/auth';
import { SignIn } from './SignIn';

type AuthState = 'checking' | 'signed-out' | 'signed-in';

interface AuthGateProps {
  children: ReactNode;
}

export function AuthGate({ children }: AuthGateProps) {
  const [state, setState] = useState<AuthState>(env.mock ? 'signed-in' : 'checking');

  const check = useCallback(async () => {
    if (env.mock) {
      setState('signed-in');
      return;
    }
    const ok = await isSignedIn();
    setState(ok ? 'signed-in' : 'signed-out');
  }, []);

  useEffect(() => {
    check();
    if (env.mock) return;
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signedIn' || payload.event === 'tokenRefresh') {
        setState('signed-in');
      } else if (payload.event === 'signedOut' || payload.event === 'tokenRefresh_failure') {
        setState('signed-out');
      }
    });
    return unsubscribe;
  }, [check]);

  if (state === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center text-inkFaded font-serif italic text-display-sm">
        One moment…
      </div>
    );
  }

  if (state === 'signed-out') {
    return <SignIn onSignedIn={() => setState('signed-in')} />;
  }

  return <>{children}</>;
}
